// Load More pagination for collection pages.
// Also re-expands previously loaded pages when the user navigates back to the
// grid, so the saved scroll position lands on the products they were viewing
// instead of a collapsed first page.
(function () {
  var STORAGE_KEY = 'collection_loaded_pages';
  var MAX_RESTORE_PAGES = 30;

  function currentUrlKey() {
    return window.location.pathname + window.location.search;
  }

  function getLoadedPagesMap() {
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  }

  function saveLoadedPage(pageNumber) {
    try {
      var map = getLoadedPagesMap();
      map[currentUrlKey()] = pageNumber;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch {
      // sessionStorage unavailable
    }
  }

  function clearLoadedPages() {
    try {
      var map = getLoadedPagesMap();
      if (map[currentUrlKey()] !== undefined) {
        delete map[currentUrlKey()];
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
      }
    } catch {
      // sessionStorage unavailable
    }
  }

  function pageNumberFromUrl(url) {
    try {
      var page = new URL(url, window.location.origin).searchParams.get('page');
      return page ? parseInt(page, 10) : null;
    } catch {
      return null;
    }
  }

  function urlForPage(templateUrl, pageNumber) {
    var url = new URL(templateUrl, window.location.origin);
    url.searchParams.set('page', pageNumber);
    return url.pathname + url.search;
  }

  function appendPageItems(parsed) {
    var newItems = parsed.querySelectorAll('#product-grid > li');
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // Defence in depth against duplicate products: the disabled-button guard
    // below closes the click-vs-restore race, but a re-triggered restore could
    // still append a page that is already in the grid. Skip items whose
    // product link is already present.
    var seenUrls = {};
    grid.querySelectorAll('li a[href]').forEach(function (a) {
      seenUrls[a.getAttribute('href')] = true;
    });

    newItems.forEach(function (item) {
      var link = item.querySelector('a[href]');
      var url = link && link.getAttribute('href');
      if (url) {
        if (seenUrls[url]) return;
        seenUrls[url] = true;
      }
      grid.appendChild(item);
    });
  }

  // Point the button at the next page after the given document, or remove it
  // when there are no more pages.
  function updateButtonFrom(parsed, button) {
    var nextButton = parsed.getElementById('LoadMoreButton');
    if (nextButton && nextButton.dataset.nextUrl) {
      button.dataset.nextUrl = nextButton.dataset.nextUrl;
      button.disabled = false;
    } else {
      var wrapper = document.getElementById('CollectionLoadMore');
      if (wrapper) wrapper.remove();
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('#LoadMoreButton');
    if (!button) return;

    var url = button.dataset.nextUrl;
    if (!url) return;

    button.disabled = true;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        appendPageItems(parsed);
        var loadedPage = pageNumberFromUrl(url);
        if (loadedPage) saveLoadedPage(loadedPage);
        updateButtonFrom(parsed, button);
      })
      .catch(function () {
        button.disabled = false;
      });
  });

  // A navigation where the user expects to find the grid as they left it:
  // the app-mode back button (which sets the scroll-restore flag), a return
  // from the auth flow, or the browser's own back/forward/reload.
  function isReturningNavigation() {
    try {
      if (sessionStorage.getItem('app_should_restore_scroll') === 'true') return true;
      if (sessionStorage.getItem('restore_the_scroll') === 'true') return true;
    } catch {
      // sessionStorage unavailable
    }
    var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    if (entries && entries.length) {
      return entries[0].type === 'back_forward' || entries[0].type === 'reload';
    }
    return false;
  }

  function restoreLoadedPages() {
    var targetPage = getLoadedPagesMap()[currentUrlKey()];
    if (!targetPage || targetPage < 2) return;

    if (!isReturningNavigation()) {
      // Fresh visit: the grid starts collapsed again, so drop the stale state.
      clearLoadedPages();
      return;
    }

    var button = document.getElementById('LoadMoreButton');
    if (!button || !button.dataset.nextUrl) return;

    var nextUrl = button.dataset.nextUrl;
    var firstPage = pageNumberFromUrl(nextUrl) || 2;
    targetPage = Math.min(targetPage, MAX_RESTORE_PAGES);
    if (firstPage > targetPage) return;

    // Tell theme.liquid's scroll restoration to hold off (behind the white
    // page-load overlay) until the grid is expanded, so the saved scroll
    // position isn't clamped to a shorter page.
    window.loadMoreRestoreInProgress = true;

    // Disable the button for the duration of the restore fetches. Without
    // this, a click on the still-enabled button during restoreLoadedPages()
    // races the manual click handler against this function: both fetch and
    // append the same page, duplicating products in the grid.
    button.disabled = true;

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      window.loadMoreRestoreInProgress = false;
      button.disabled = false;
      window.dispatchEvent(new CustomEvent('loadMoreRestored'));
    }

    // Safety net: never hold the scroll restore (and overlay) hostage.
    setTimeout(finish, 8000);

    var requests = [];
    for (var page = firstPage; page <= targetPage; page++) {
      requests.push(fetch(urlForPage(nextUrl, page)).then(function (r) { return r.text(); }));
    }

    Promise.all(requests)
      .then(function (htmlPages) {
        var lastParsed = null;
        htmlPages.forEach(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          appendPageItems(parsed);
          lastParsed = parsed;
        });
        if (lastParsed) updateButtonFrom(lastParsed, button);
      })
      .catch(function () {
        // Leave the button usable so the user can still load pages manually.
      })
      .then(finish);
  }

  restoreLoadedPages();
})();
